import React, { 
   useEffect,
   useState } from 'react';
import './BackofficeTransactions.scss';
import { connect } from 'react-redux';
import MercurXBackofficeTransactionTable 
from '../../components/MercurXBackofficeTransactionTable/MercurXBackofficeTransactionTable';
import MercurXDateRangePicker
from '../../components/MercurXDateRangePicker/MercurXDateRangePicker';
import {
  getBackofficeTransactionsActionRequest,
  filterBackofficeTransactionsAction,
  sortBackofficeTransactionsAction,
  updateAssetFilterAction,
  updateQuickFilterAction
} from '../../store/bo_transaction/bo_transactionActions';
import { Col, Form, Row, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import 
{
  backofficeTransactionsAssetFilterConstants,
  backofficeTransactionsQuickFilterConstants,
}
 from './backofficeTransactionsConstants';


function BackofficeTransactions({ ...props }) {
  const {
    getBackofficeTransactionsRequest,
    backofficeTransactions,
    assetFilter,
    quickFilter,
    updateAssetFilter,
    updateQuickFilter,
    sortBackofficeTransactions,
    filterBackofficeTransactions,
  } = props;

  const [filterInput, setFilterInput] = useState('');
  const [dateRange, setDateRange] = useState({ startDate: null, endDate: null });

  useEffect(() => {
    getBackofficeTransactionsRequest();
    updateQuickFilter(backofficeTransactionsQuickFilterConstants.ALL)
    updateAssetFilter(backofficeTransactionsAssetFilterConstants.ALL)
  }, []);
  useEffect(() => {
    filterBackofficeTransactions({
      search: filterInput,
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
    });
    sortBackofficeTransactions();
  }, [quickFilter, assetFilter]);

  useEffect(() => {
    filterBackofficeTransactions({
      search: filterInput,
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
    });
    sortBackofficeTransactions();
  }, [filterInput, dateRange])

  useEffect(() => {
    filterBackofficeTransactions({
      search: filterInput,
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
    });
    sortBackofficeTransactions();
  }, [backofficeTransactions]);

  return (
<>
      <div className="text-fs-head-md mb-4">Backoffice Transactions</div>
      <div className="transactions-filter-panel mt-4">
        <div className="filter-panel-title">Filters</div>
        <Row className="g-3 align-items-end">
          <Col lg={8}>
            <Form.Label className="filter-control-label">Text Search</Form.Label>
            <Form.Control
              className="text-fs-body-sm filter-control-input"
              type="text"
              placeholder="Search by contract name, address or txn hash..."
              aria-label="Backoffice transaction text search"
              aria-describedby="basic-addon1"
              value={filterInput}
              onChange={(e) => setFilterInput(e.target.value)}
              size={'sm'}
            />
          </Col>
          <Col lg={4}>
            <MercurXDateRangePicker
              label="Txn Date Range"
              startDate={dateRange.startDate}
              endDate={dateRange.endDate}
              onChange={setDateRange}
            />
          </Col>
        </Row>
      </div>
      <Row
        id="transactions-container"
        className="d-flex align-items-center justify-content-end mt-4"
      >
        <Col className="text-md-end">
        <ToggleButtonGroup size={'sm'} type="radio" name="asset-options" defaultValue={1}
          className="me-2">
            <ToggleButton
              size={'sm'}
              variant={assetFilter === backofficeTransactionsAssetFilterConstants.ALL ?
                 'primary' : 'light'}
              className={
                assetFilter !== backofficeTransactionsAssetFilterConstants.ALL ?
                 'text-t-body-color' : ''
              }
              id="asset-radio-1"
              value={backofficeTransactionsAssetFilterConstants.ALL}
              onClick={() => updateAssetFilter(backofficeTransactionsAssetFilterConstants.ALL)}
            >
              All Assets
            </ToggleButton>
            <ToggleButton
              size={'sm'}
              variant={assetFilter === backofficeTransactionsAssetFilterConstants.TOKEN ?
                 'primary' : 'light'}
              className={
                assetFilter !== backofficeTransactionsAssetFilterConstants.TOKEN ?
                 'text-t-body-color' : ''
              }
              id="asset-radio-2"
              value={backofficeTransactionsAssetFilterConstants.TOKEN}
              onClick={() => updateAssetFilter(backofficeTransactionsAssetFilterConstants.TOKEN)}
            >
              Token
            </ToggleButton>
            <ToggleButton
              size={'sm'}
              variant={assetFilter === backofficeTransactionsAssetFilterConstants.NFT ?
                 'primary' : 'light'}
              className={
                assetFilter !== backofficeTransactionsAssetFilterConstants.NFT ?
                 'text-t-body-color' : ''
              }
              id="asset-radio-3"
              value={backofficeTransactionsAssetFilterConstants.NFT}
              onClick={() => updateAssetFilter(backofficeTransactionsAssetFilterConstants.NFT)}
            >
              NFT
            </ToggleButton>
          </ToggleButtonGroup>
        <ToggleButtonGroup size={'sm'} type="radio" name="options" defaultValue={1}>
            <ToggleButton
              size={'sm'}
              variant=
              {quickFilter === backofficeTransactionsQuickFilterConstants.ALL ? 'primary' : 'light'}
              className={
                quickFilter !== backofficeTransactionsQuickFilterConstants.ALL ? 'text-t-body-color'
                 : ''
              }
              id="tbg-radio-1"
              value={backofficeTransactionsQuickFilterConstants.ALL}
              onClick={() => updateQuickFilter(backofficeTransactionsQuickFilterConstants.ALL)}
            >
              All
            </ToggleButton>
            <ToggleButton
              size={'sm'}
              variant={quickFilter ===
                 backofficeTransactionsQuickFilterConstants.TRUE ? 'primary' : 'light'}
              className={
                quickFilter !== 
                backofficeTransactionsQuickFilterConstants.TRUE ? 'text-t-body-color' : ''
              }
              id="tbg-radio-2"
              value={backofficeTransactionsQuickFilterConstants.TRUE}
              onClick={() => updateQuickFilter(backofficeTransactionsQuickFilterConstants.TRUE)}
            >
              Success
            </ToggleButton>
            <ToggleButton
              size={'sm'}
              variant={quickFilter ===
                 backofficeTransactionsQuickFilterConstants.FALSE ? 'primary' : 'light'}
              className={
                quickFilter !== 
                  backofficeTransactionsQuickFilterConstants.FALSE ? 'text-t-body-color' : ''
              }
              id="tbg-radio-3"
              value={backofficeTransactionsQuickFilterConstants.FALSE}
              onClick={() => updateQuickFilter(backofficeTransactionsQuickFilterConstants.FALSE)}
            >
              Fail
            </ToggleButton>
          </ToggleButtonGroup>
        </Col>
      </Row>
      <div id="transactions-container">
        <MercurXBackofficeTransactionTable />
      </div>
       </>
  );
}
const mapStateToProps = (state) => {
  return {
    backofficeTransactions: state.backofficeTransactionReducer.backofficeTransactions,
    assetFilter: state.backofficeTransactionReducer.assetFilter,
    quickFilter: state.backofficeTransactionReducer.quickFilter,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getBackofficeTransactionsRequest: (payload) => {
      dispatch(getBackofficeTransactionsActionRequest(payload));
    },
    updateQuickFilter: (payload) => {
      dispatch(updateQuickFilterAction(payload));
    },
    updateAssetFilter: (payload) => {
      dispatch(updateAssetFilterAction(payload));
    },
    sortBackofficeTransactions: (payload) => {
      dispatch(sortBackofficeTransactionsAction(payload));
    },
    filterBackofficeTransactions: (payload) => {
      dispatch(filterBackofficeTransactionsAction(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BackofficeTransactions);
